//NORMAL IMAGES
import img1 from '../assets/gallery/galeria1.jpg'
import img2 from '../assets/gallery/galeria2.jpg'
import img3 from '../assets/gallery/galeria3.jpg'
import img4 from '../assets/gallery/galeria4.jpg'
import img5 from '../assets/gallery/galeria5.jpg'
import img6 from '../assets/gallery/galeria6.jpg'
import img7 from '../assets/gallery/galeria7.jpg'
import img8 from '../assets/gallery/galeria8.jpg'
import img9 from '../assets/gallery/galeria9.jpg'
import img10 from '../assets/gallery/galeria10.jpg'
import img11 from '../assets/gallery/galeria11.jpg'
import img12 from '../assets/gallery/galeria12.jpg'
import img13 from '../assets/gallery/galeria13.jpg'
import img14 from '../assets/gallery/galeria14.jpg'
import img15 from '../assets/gallery/galeria15.jpg'
import img16 from '../assets/gallery/galeria16.jpg'
import img17 from '../assets/gallery/galeria17.jpg'
import img18 from '../assets/gallery/galeria18.jpg'
import img19 from '../assets/gallery/galeria19.jpg'
import img20 from '../assets/gallery/galeria20.jpg'
import img21 from '../assets/gallery/galeria21.jpg'
import img22 from '../assets/gallery/galeria22.jpg'
import img23 from '../assets/gallery/galeria23.jpg'
import img24 from '../assets/gallery/galeria24.jpg'
import img25 from '../assets/gallery/galeria25.jpg'
import img26 from '../assets/gallery/galeria26.jpg'
import img27 from '../assets/gallery/galeria27.jpg'
import img28 from '../assets/gallery/galeria28.jpg'
import img29 from '../assets/gallery/galeria29.jpg'

export const galleryImages=[
    {
        id:1,
        src:img1,
    },
    {
        id:2,
        src:img2,
    },
    {
        id:3,
        src:img3,
       
    },
    {
        id:4,
        src:img4,
    },
    {
        id:5,
        src:img5,
    },
    {
        id:6,
        src:img6,
    },
    {
        id:7,
        src:img7,
    },
    {
        id:8,
        src:img8,
    },
    {
        id:9,
        src:img9,
    },
    {
        id:10,
        src:img10,
    },
    {
        id:11,
        src:img11,
    },
    {
        id:12,
        src:img12,
    },
    {
        id:13,
        src:img13,
    },
    {
        id:14,
        src:img14,
    },
    {
        id:15,
        src:img15,
    },
    {
        id:16,
        src:img16,
    },
    {
        id:17,
        src:img17,
    },
    {
        id:18,
        src:img18,
    },
    {
        id:19,
        src:img19,
    },
    {
        id:20,
        src:img20,
    },
    {
        id:21,
        src:img21,
    },
    {
        id:22,
        src:img22,
    },
    {
        id:23,
        src:img23,
    },
    {
        id:24,
        src:img24,
    },
    {
        id:25,
        src:img25,
    },
    {
        id:26,
        src:img26,
    },
    {
        id:27,
        src:img27
    },
    {
        id:28,
        src:img28
    },
    {
        id:29,
        src:img29
    }

]